import { BACKEND_FETCH_PINWHEEL_ELIGIBILITY } from '@perpay-web/fintech/constants/actionTypes';

export function fetchPinwheelEligibility() {
    return {
        type: BACKEND_FETCH_PINWHEEL_ELIGIBILITY,
    };
}
